import { render } from "./header.vue?vue&type=template&id=276dcb4e&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=276dcb4e&lang=less&scoped=true"

import exportComponent from "E:\\a工互\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276dcb4e"]])

export default __exports__